/**
 * Enabled button onload
 * Buttons are by default disabled from backend (ascx.cs)
 * When JS is loaded remove disabled from buttons
 * This is to prevent users from interact with buttons until JS is loaded
 */

export class EnableButtonOnload {
    constructor(el) {
        this._refs = {
            el: el
        };

        this._refs.el.parentNode.classList.remove('enable_button_onload-loading');
        this._refs.el.removeAttribute('disabled');
    }
}